module.exports = __webpack_public_path__ + "c99cbff8263a6ee711e1350c639f7670.pdf";